module.exports = __webpack_public_path__ + "img/smarttrucklogo.32052d99.png";